// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-pagination .ant-select {
  width: 50px !important;
  height: 20px !important;
}
/* .page-number .ant-pagination-item-active {
  padding: 0.5rem 0.75rem !important;
  font-size: 0.8rem !important;
  font-weight: 700 !important;
  border-radius: var(--phoenix-border-radius) !important;
  line-height: 1.2 !important;
  background-color: #f17a20 !important;
} */
`, "",{"version":3,"sources":["webpack://./src/components/shares/Pagination/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;;;;;;GAOG","sourcesContent":[".custom-select-pagination .ant-select {\n  width: 50px !important;\n  height: 20px !important;\n}\n/* .page-number .ant-pagination-item-active {\n  padding: 0.5rem 0.75rem !important;\n  font-size: 0.8rem !important;\n  font-weight: 700 !important;\n  border-radius: var(--phoenix-border-radius) !important;\n  line-height: 1.2 !important;\n  background-color: #f17a20 !important;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
